import { render } from "./SearchOrderModal.vue?vue&type=template&id=706aea62&scoped=true"
import script from "./SearchOrderModal.vue?vue&type=script&lang=js"
export * from "./SearchOrderModal.vue?vue&type=script&lang=js"

import "./SearchOrderModal.vue?vue&type=style&index=0&id=706aea62&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-706aea62"]])

export default __exports__